module.exports = __webpack_public_path__ + "static/img/poma_img4.14c82611.jpg";